import React from 'react';
import { Tab } from "react-bootstrap";

const getMarkdownTab = ({
  contenido,
  articulo,
}) => {

  return <Tab
  eventKey="markdown"
  title={
    <>
      <i className="fab fa-markdown"></i> Markdown
    </>
  }
>
  <div className="row" style={{ textAlign: "left" }}>
    {articulo?.contenido && (
      <div className="col-sm">
        <br />
        <br />
        <h3>Versión Actual:</h3>
        <br />
        <div>
          <code
            style={{
              overflowWrap: "break-word",
              whiteSpace: "pre-wrap",
              color: "#aaa",
            }}
          >
            {articulo?.contenido}
          </code>
        </div>
      </div>
    )}
    {contenido && (
      <div className="col-sm">
        <br />
        <br />
        <h3>Propuesto:</h3>
        <br />
        <div>
          <code
            style={{
              overflowWrap: "break-word",
              whiteSpace: "pre-wrap",
              color: "#aaa",
            }}
          >
            {contenido}
          </code>
        </div>
      </div>
    )}
  </div>
</Tab>
}

export default getMarkdownTab